import { defineMessages } from 'react-intl';

export default defineMessages({
    stepCoverables: {
        id: 'quoteandbind.EveLiaProduct.wizard.step.Coverables',
        defaultMessage: 'Coverables',
    },
    questions: {
        id: 'quoteandbind.EveLiaProduct.wizard.step.Questions',
        defaultMessage: 'Questions',
    },
    stepCoverages: {
        id: 'quoteandbind.EveLiaProduct.wizard.step.Coverages',
        defaultMessage: 'Coverages',
    },
    exposures: {
        id: 'quoteandbind.EveLiaProduct.wizard.step.Exposures',
        defaultMessage: 'Exposures',
    },
    // add string ids and default values for localization here
});
